import { Subscription } from '../../hooks/subscriptionApi';
import { ApiResponse } from '../../../../../api/types';
import { Coupon } from '@jbhi-fi/components/src/types';

export type SubscriptionApiRecord = {
  id: string;
  customerId: string;
  type: string;
  isActive: boolean;
  startDate: string;
  endDate?: string;
  parentId?: string;
  sourceSystemId: string;
  sourceSystem: string;
  sourceLocation: string;
  entityId: number;
  coupons?: Array<Coupon>;
};

export enum SubscriptionTypes {
  perks = 'JBPerks',
}

export type SubscriptionApiResponse = ApiResponse<Subscription>;
